import { render, staticRenderFns } from "./JobBoard.vue?vue&type=template&id=1f4e1e71&scoped=true&"
import script from "./JobBoard.vue?vue&type=script&lang=js&"
export * from "./JobBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4e1e71",
  null
  
)

export default component.exports